// extracted by mini-css-extract-plugin
module.exports = {"WrapperFeaturedShortmessages":"nmns","InnerFeatured":"yLhe","InnerShortmessages":"EdD6"};